import { render, staticRenderFns } from "./CoursewareCollapsibleBox.vue?vue&type=template&id=67439ed4&"
import script from "./CoursewareCollapsibleBox.vue?vue&type=script&lang=js&"
export * from "./CoursewareCollapsibleBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports